import { LoaderFunctionArgs, redirect } from 'react-router-dom'

import { authApi } from '../../services/auth'
import { userApi } from '../../services/user'
import { eventsApi } from '../../services/events'
import type { AppStore } from '../../store'
import { replace } from '../../utils'

export const authenticate =
  (store: AppStore) =>
  async ({ request }: LoaderFunctionArgs) => {
    const formData = await request.formData()

    const res = await store.dispatch(
      authApi.endpoints.login.initiate({
        email: formData.get('email') as string,
        password: formData.get('password') as string,
      })
    )

    if ('error' in res && res.error) {
      return false
    }

    if ('data' in res) {
      const path = new URL(request.url).searchParams.get('from') ?? '/dashboard'
      return redirect(path)
    }

    return false
  }

export const wordpressAuthenticate =
  (store: AppStore) =>
  async ({ request }: LoaderFunctionArgs) => {
    const code = new URL(request.url).searchParams.get('code')

    if (!code) {
      console.error('No code provided for WordPress authentication')
      return false
    }

    const res = await store.dispatch(
      authApi.endpoints.wordpressLogin.initiate({
        code,
      })
    )

    if ('error' in res && res.error) {
      return false
    }

    if ('data' in res) {
      const path = new URL(request.url).searchParams.get('state') ?? '/dashboard'
      return redirect(decodeURIComponent(path))
    }

    return false
  }

export const logout =
  (store: AppStore) =>
  async ({ request }: LoaderFunctionArgs) => {
    const res = await store.dispatch(authApi.endpoints.logout.initiate())

    if ('error' in res && res.error) {
      // just do nothing for now we still want to logout locally
    }

    // TODO check issue with hooks being called after logout
    // https://github.com/reduxjs/redux-toolkit/issues/4009
    store.dispatch(authApi.util.resetApiState())
    store.dispatch(userApi.util.resetApiState())
    store.dispatch(eventsApi.util.resetApiState())

    return replace(`/login?${new URL(request.url).searchParams.toString()}`)
  }
